import React from "react";
import { store, persister } from "../configure-app";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { App } from "./App";
import { Grid } from "@material-ui/core";

export const ConfiguredApp = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <Router>
        <Grid container justify="center" style={{ height: '100vh' }}>
          <App />
        </Grid>
      </Router>
    </PersistGate>
  </Provider>
);
